module.exports = __webpack_public_path__ + "static/assets/1c66f0ca853464c6dc52c4052c506139.svg";